export const reduceEventDetails = (event) => {
  if (!event) return {};
  const {
    title,
    startStr,
    endStr,
    allDay = false,
    extendedProps: { weddingId, weddingName, location, googleLocation, notes },
  } = event;
  return { title, weddingId, weddingName, startStr, endStr, allDay, location, googleLocation, notes };
};
